import { useEffect } from 'react';
import { useThemeStore } from '../stores/useThemeStore';
import type { ThemeMode, ResolvedTheme } from '../stores/useThemeStore';

export function useTheme() {
  const { theme, resolvedTheme, setTheme, _applyTheme } = useThemeStore();

  // Listen for system preference changes when theme === 'auto'
  useEffect(() => {
    if (theme !== 'auto') return;

    const mediaQuery = window.matchMedia('(prefers-color-scheme: light)');
    const handler = () => _applyTheme('auto');

    mediaQuery.addEventListener('change', handler);
    return () => mediaQuery.removeEventListener('change', handler);
  }, [theme, _applyTheme]);

  return { theme, resolvedTheme, setTheme };
}

export type { ThemeMode, ResolvedTheme };
